export default {
   toolbarButtons: {
      moreText: {
         buttons: ['paragraphFormat', 'bold', 'italic', 'underline'],
         buttonsVisible: 4
      },
      moreMisc: {
         buttons: [
            'strikeThrough',
            'formatOL',
            'formatUL',
            'insertLink',
            'insertTable'
         ],
         buttonsVisible: 5
      }
   },
   toolbarButtonsSM: {
      moreText: {
         buttons: ['paragraphFormat', 'bold', 'italic', 'underline'],
         buttonsVisible: 4
      },
      moreMisc: {
         buttons: [
            'strikeThrough',
            'formatOL',
            'formatUL',
            'insertLink',
            'insertTable'
         ],
         buttonsVisible: 5
      }
   },
   toolbarButtonsXS: {
      moreText: {
         buttons: ['bold', 'italic', 'underline'],
         buttonsVisible: 3
      },
      moreMisc: {
         buttons: [
            'paragraphFormat',
            'strikeThrough',
            'formatOL',
            'formatUL',
            'insertLink',
            'insertTable'
         ],
         buttonsVisible: 0
      }
   }
}
